import { generateUtilityClass } from "../generateUtilityClass/index.js";
import { generateUtilityClasses } from "../generateUtilityClasses/index.js";
var COMPONENT_NAME = 'Switch';
export function getSwitchUtilityClass(slot) {
    return generateUtilityClass(COMPONENT_NAME, slot);
}
export var switchClasses = generateUtilityClasses(COMPONENT_NAME, [
    'root',
    'input',
    'track',
    'thumb',
    'checked',
    'disabled',
    'focusVisible',
    'readOnly'
]);
